const DefaultThemeLight = {
  sidePanelBackground: "#F9FAFB",
  mainBackground: "white",
  colorPrimary: "#16697a",
  tagBackgroundColor: "#16697a",
  tagTextColor: "white",
};

export default DefaultThemeLight;
